var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "about-takeover", attrs: { "aria-hidden": "true" } },
    _vm._l(_vm.images, function(img) {
      return _c("img", {
        staticClass: "popup",
        style: { left: img.x + "%", top: img.y + "%" },
        attrs: { src: img.src }
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }